import MyTabs from '../../components/MyTabs';
import Section1 from './VirtualTour';

const GeneralVirtualTours = () => {

    const tabs = [
        { id: "Basic", title: "Basic Virtual Tours Info", Component: Section1 },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default GeneralVirtualTours;